import { AvailableProducts } from 'app/constants/Products';

export const createIntake = (name, step) => `/dashboard/intake/${name}/${step}`;

export const createIntakeClinicalQuestions = (name) => `/dashboard/intake/${name}/clinical_question`;
export const Admin = '/admin';
export const AdminLabs = '/admin/labs';
export const AdminSendgridConfig = '/admin/sendgrid/config';
export const AdminTassoApiTesting = '/admin/tasso-api-testing';
export const AdminScheduleAppointment = '/admin/:userId/schedule_appointment';
export const AdminRescheduleAppointment = '/admin/:userId/reschedule_appointment';
export const Dashboard = '/dashboard';
export const Onboarding = createIntake('onboarding', ':step');
export const ContinueOnboarding = '/dashboard/continue-onboarding';
export const ContinueIntake = '/dashboard/continue-intake';
export const Intake = createIntake(':intakeName', ':intakeStep');
export const ClinicalQuestion = createIntakeClinicalQuestions(':intakeName');
export const Settings = '/dashboard/account-preferences';
export const ContactUs = '/dashboard/contact-us';
export const TrackReferrals = '/dashboard/track-referrals';
export const ApplySubscriptionDeal = '/dashboard/manage-subscriptions/apply_deal';
export const ManageSubscription = '/dashboard/manage-subscriptions';
export const UpdateSubscription = `/dashboard/update-subscription`;
export const UpdateSubscriptionForProduct = (product: string) => `${UpdateSubscription}?product=${product}`;
export const BillingSettings = '/dashboard/billing-preferences';
export const WarriorRetakePhotos = '/dashboard/warrior-retake-photos/:step';
export const PasswordSettings = '/dashboard/password-preferences';
export const ScheduleAppointment = '/dashboard/schedule_appointment';
export const ReScheduleAppointment = '/dashboard/reschedule_appointment';
export const LabCheckout = '/dashboard/lab_checkout';
export const LabCheckoutSuccess = '/dashboard/lab_success';
export const UploadOwnLabs = '/dashboard/upload_own_lab';
export const AnnualLabCheckout = '/dashboard/annual_lab_checkout/:lab_type';
export const Messages = '/dashboard/messages';
export const MessagesNew = '/dashboard/messages/new';
export const MessagesThread = '/dashboard/messages/:thread_id';
export const Login = '/login';
export const PasswordReset = '/password/reset';
export const Registration = '/registration';
export const ProductSelection = 'https://www.maximustribe.com/#view';
export const ComingSoon = '/coming-soon';
export const Goodbye = '/goodbye';
export const Root = '/';
export const Apologize = '/apologize';
export const AccessibilityStatement = '/accessibility-statement';
export const TermsOfUse = '/terms-of-use';
export const PrivacyPolicy = '/privacy-policy';
export const PharmacyConfiguration = '/admin/pharmacy_config';
export const PhysiciansConfiguration = '/admin/physicians_config';
export const ProductDashboard = (product: string | undefined) =>
  product && product !== AvailableProducts.King ? `${Dashboard}?product=${product}` : Dashboard;
export const UpdateQuestionnaire = '/dashboard/:product/update-questionnaire';
export const LabSelection = '/dashboard/intake/onboarding/lab_selection';
export const BuiltWithDoctors = '/dashboard/intake/onboarding/built_with_doctors';
export const TestosteroneTestimonials = '/dashboard/intake/onboarding/testosterone_testimonials';
export const TestosteroneEnergyLevel = '/dashboard/intake/onboarding/testosterone_energy_level';
export const NotificationCenter = '/dashboard/notification_center';
export const HealthRejected = '/dashboard/product-unavailable';
